import Crud from '../views/ManualGrupo/Crud';
import Add from '../views/ManualGrupo/Add';
import Tree from '../views/ManualGrupo/Tree';

let routes = {
    path: '/manual-grupos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/manual-grupos',
            name: 'list-manual-grupos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Grupos de Manual',
                breadcrumb: [
                    {
                        text: 'grupos de manual',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/manual-grupos/add',
            name: 'new-manual-grupo',
            component: Add,
            meta: {
                pageTitle: 'Novo Grupo de Manual',
                breadcrumb: [
                    {
                        text: 'grupos de manual',
                        active: false,
                        to: '/manual-grupos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/manual-grupos/edit/:id?',
            name: 'edit-manual-grupo',
            component: Add,
            meta: {
                pageTitle: 'Editar Grupo de Manual',
                breadcrumb: [
                    {
                        text: 'grupos de manual',
                        active: false,
                        to: '/manual-grupos',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/manual-grupos/tree',
            name: 'manual-grupos-tree',
            component: Tree,
            meta: {
                pageTitle: 'Árvore de Grupos de Manual',
                breadcrumb: [
                    {
                        text: 'grupos de manual',
                        active: false,
                        to: '/manual-grupos',
                    },
                    {
                        text: 'Árvore',
                        active: true,
                    },
                ],
            },
        },
    ],
};

export default routes;
